import React, { useEffect } from 'react';
import { IColorwayProductData, IVariant, TUserSelections } from '../../types/PDP';
import { bopisState } from './bopisState';
import { observer } from 'mobx-react-lite';
import { StoreLocatorPDP } from '../StoreLocator/StoreLocatorPDP';
import { reaction } from 'mobx';
import { customerLocationState } from '../StoreLocator/customerLocationState';
import { storeLocatorSidebarState } from '../StoreLocator/storeLocatorSidebarState';
import { isTagPresent } from 'src/scripts/utils/helpers';
import { HIDDEN_INVENTORY_TAG } from 'src/scripts/utils/constants';

let BopisContainer = ({
  selectedVariant,
  product,
  userSelections,
}: {
  selectedVariant: IVariant | undefined;
  product: IColorwayProductData;
  userSelections: TUserSelections;
}) => {
  const userSelectedSize = userSelections[0].Size;
  const isAvailableOnline =
    Boolean(selectedVariant?.availableForSale) && !isTagPresent(product.tags, HIDDEN_INVENTORY_TAG);

  useEffect(() => {
    if (selectedVariant && selectedVariant.sku) bopisState.fetchStoresDataPdp(selectedVariant, true); // single tile fetch
    const disposeCustomerLocationChangeOnPdpReaction = reaction(
      () => [customerLocationState.coordinates, storeLocatorSidebarState.isOpen],
      () => {
        if (selectedVariant && selectedVariant.sku) bopisState.fetchStoresDataPdp(selectedVariant);
      }
    );

    return () => {
      disposeCustomerLocationChangeOnPdpReaction();
    };
  }, [selectedVariant]);

  const sidebarPdpData = {
    product,
    userSelectedSize,
    selectedVariant,
    isAvailableOnline,
  };

  return (
    <StoreLocatorPDP
      title={'Buy Online, Pick up in Store'}
      userSelectedSize={userSelectedSize}
      storeLocatorType={'bopis'}
      sidebarPdpData={sidebarPdpData}
      selectedVariant={selectedVariant}
      isLoading={bopisState.isFetchingData}
    />
  );
};

BopisContainer = observer(BopisContainer);
export { BopisContainer };
